export default {
  title: 'Hesabım',
  gobitoLinkText: 'HESAP BİLGİLERİM NASIL KULLANILIR?',
  tabs: {
    userInformation: 'KULLANICI BİLGİLERİ',
    accountInformation: 'FİRMA BİLGİLERİ',
    bankInformation: 'BANKA BİLGİLERİ',
    addressInformation: 'ADRES BİLGİLERİ',
    cargoInformation: 'KARGO BİLGİLERİ',
    integrationInformation: 'ENTEGRASYON BİLGİLERİ',
    sellerContactsInformation: 'İLETİŞİM BİLGİLERİ',
    holidayMode: 'TATİL MODU',
    workingModeSettings: 'COVİD-19 ÇALIŞMA DURUMU',
    communicationSettings: 'İLETİŞİM TERCİHLERİ',
  },
  sellerContact: 'İletişim Bilgisi #{value}',
  cargoFirm: 'Kargo Firma Bilgisi #{value}',
  contactTypeName: 'İletişim Tipi',
  fullName: 'Ad ve Soyad',
  email: 'E-Mail',
  phone: 'Telefon',
  createDate: 'Oluşturulma Tarihi',
  description: 'Açıklama',
  save: 'Kaydet',
  edit: 'Düzenle',
  updatePassword: 'Şifremi Güncelle',
  logoutAllUsers: {
    btnText: 'Tüm Oturumlarımı Kapat',
    modal: {
      content: 'Hesabınız için tüm cihazlarda oturumlarınızı kapatmak istediğinize emin misiniz?',
      submitBtnText: 'TÜM OTURUMLARIMI KAPAT',
      cancelBtnText: 'VAZGEÇ',
    },
  },
  default: 'Varsayılan',
  defaultAddressTooltip: 'Ürün aktarımı veya güncellemesi yaparken “Sevkiyat depo adresi ID” ve “İade depo adresi ID” değerlerini boş göndermeniz halinde varsayılan adres id niz otomatik olarak eşlenecektir.',
  address: 'Adres',
  addressId: 'Adres ID',
  cargoPrices: 'Kargo Fiyatları',
  phoneNumber: 'Telefon',
  shipmentAddress: 'Sevkiyat Adresi',
  returnAddress: 'İade Adresi',
  invoiceAddress: 'Fatura Adresi',
  copyToClipboard: 'Kopyalandı.',
  noAddress: 'Adres bilgisi bulunmamaktadır.',
  modal: {
    'address-edit': 'Adres Düzenle',
    'address-add': 'Adres Ekle',
    'changeSellerName': 'Mağaza Adını Değiştir',
  },
  copy: 'Kopyala',
  labels: {
    mersisNo: 'Mersis No',
    kepAddress: 'KEP Adresi',
    iban: 'IBAN',
    name: 'Mağaza Adı',
    sellerName: 'Mağaza Adı',
    currentAccountName: 'Cari Ünvanı',
    sellerId: 'Satıcı Id',
    apiKey: 'API Key',
    apiSecret: 'API Secret',
    taxOfficeNo: 'Vergi Numarası',
    taxOffice: 'Vergi Dairesi',
    cargoFirm: 'Kargo Firması',
    firmName: 'Firma Adı',
    cargoRate: 'Çalışma Oranı',
    cargoShipmentPayerModel: 'Çalışma Modeli',
    shipmentPayer: 'Kargo Firması ile Çalışma Modeli',
    trendyolPay: 'Trendyol’un Anlaşmalı Fiyatları ile Çalışma',
    sellerPay: 'Kendi Anlaşmalı Fiyatları ile Çalışma',
    address: 'Adres',
    city: 'Şehir',
    district: 'İlçe',
    postalCode: 'Posta Kodu',
    isDefault: 'Ön Tanımlı Adres',
    userPhone: 'Telefon Numaram',
    myPassword: 'Şifrem',
    userEmail: 'E-Posta Adresim',
    update: 'Güncelle',
    verify: 'Doğrula',
  },
  tooltipTexts: {
    kepAddress: 'Kayıtlı Elektronik Posta (KEP) her türlü ticari, hukuki yazışma ve belge paylaşımlarını gönderildiği biçimde koruyan, alıcının kim olduğunu tespit eden ve güvenli hale gelmesini sağlayan bir sistemdir. <a href="https://pttkep.gov.tr/kep-hesabimi-nasil-alabilirim/" target="_blank">https://pttkep.gov.tr/kep-hesabimi-nasil-alabilirim/</a> adresinden detaylı bilgiye ulaşabilirsiniz.',
    sellerName: 'Mağazanız trendyol.com’da bu isimle görünür.',
    mersisNo: 'Merkezi Sicil Kayıt Sistemi (MERSİS) ticari işletmelerin ve şirketlerin ticaret sicil kayıtlarının elektronik ortamda tutulması amacıyla hayata geçirilmiştir. <a href="https://mersis.gtb.gov.tr" target="_blank">https://mersis.gtb.gov.tr/</a> adresinden detaylı bilgiye ulaşabilirsiniz.',
    refetchUpdate: 'Bu alanları sadece cari ünvanı güncelle seçeneği ile değiştirebilirsiniz.',
  },
  placeholder: {
    address: 'Adres',
    city: 'Şehir',
    district: 'İlçe',
    postalCode: 'Posta Kodu',
    sellerName: 'Mağaza Adı',
    kepAddress: 'KEP Adresi Giriniz',
    mersisNo: 'Mersis No Giriniz',
  },
  updateFieldModalTitle: {
    kepAddress: 'KEP Adresini Değiştir',
    mersisNo: 'Mersis No Değiştir',
  },
  addAddressBtn: 'Yeni Adres Ekle',
  updateAddressToast: 'Adres başarıyla güncellendi.',
  asyncSuccessToast: 'Talebiniz alınmıştır. Kısa süre içerisinde güncelleme işleminiz gerçekleştirilecektir.',
  addAddressToast: 'Adres başarıyla oluşturuldu.',
  shipmentProviderInfoText: 'Seçilen kargo firması ile birlikte çalışma biçimidir. Çalışma biçimini değiştirmek için Satıcı Destek üzerinden bildirim açabilirsiniz.',
  integrationInformationWarningText: 'Entegrasyon ile çalışmıyorsanız bu alanı dikkate almayabilirsiniz.',
  renewIntegrationInformationBtn: 'API BİLGİLERİNİ GÜNCELLE',
  renewIntegrationInformationConfirmationText: 'Entegrasyon bilgilerinizde güncelleme işlemi yapmanız durumunda, API kullanıcı adınız ve şifreniz değişecektir.Değişen bilgileri entegrasyon ekibiniz ya da entegrasyonunuzu sağlayan firmanız ile paylaşmanız gerekmektedir. Aksi durumda Trendyol sistemiyle olan bağlantınız kopacağı için entegrasyon üzerinden yaptığınız işlemler Trendyol sistemine yansımayacaktır.',
  logout: 'Çıkış Yap',
  sellerNameModal: {
    ruleTitle: 'Mağaza Adı Kuralları',
    rules: {
      rule1: 'Mağaza adınız 6-40 karakter uzunluğunda olmalıdır.',
      rule2: '".com-.net" gibi uzantılar ve hiçbir şekilde iletişim bilgisi içermemelidir.',
      rule3: 'Ticari ünvanınıza tescilli markanız olmayan bir markanın ismini içermemelidir.',
      rule4: 'tic, şti, aş, anonim, san, ltd, limited, ithalat, ihracat, inş, hiz, gibi kavramlar içermemelidir.',
      rule5: 'Trendyol ifadesi içermemelidir.',
      rule6: 'İnternet satışına uygun olmayan kategori/ürün ismi içermemelidir',
      rule7: 'Şiddet, küfür ya da cinsellik içeren ifadeler yer almamalıdır.',
    },
    errors: {
      max: 'Mağaza adı alanı en az {value} karakterden oluşmalı.',
    },
    infoMessage: 'Güncellemeyi onaylıyor musunuz? 15 gün içerisinde mağaza adınızı tekrar güncelleyemeyeceksiniz.',
  },
  sso: {
    info: 'Yönlendiriliyor...',
    error: 'Bir hata oluştu.',
  },
  changeCommunicationSetting: 'İLETİŞİM TERCİHİMİ DEĞİŞTİR',
  notChangeCommunicationSetting: 'İLETİŞİM TERCİHİMİ DEĞİŞTİRME',
  changeCommunicationSettingSurvey: {
    header: {
      EMAIL: 'Bu tercihinizi değiştirdiğinizde siparişleriniz ile ilgili hiçbir e-posta alamayacaksınız.',
      SMS: 'Bu tercihinizi değiştirdiğinizde siparişleriniz ile ilgili hiçbir SMS alamayacaksınız.',
    },
    question: 'İletişim tercihinizi değiştirme nedeniniz nedir?',
    reasons: {
      notReceive: {
        EMAIL: 'E-posta almak istemiyorum.',
        SMS: 'SMS almak istemiyorum.',
        PHONE: 'Telefon almak istemiyorum',
      },
      tooMuch: {
        EMAIL: 'Çok sık e-posta geliyor.',
        SMS: 'Çok sık SMS geliyor.',
        PHONE: 'Çok fazla arama geliyor.',
      },
      notRelated: {
        EMAIL: 'Gönderilen konular benimle ilgili değil.',
        SMS: 'Gönderilen konular benimle ilgili değil.',
        PHONE: 'Arama yapılan konular benimle ilgili değil',
      },
      notInterest: {
        EMAIL: 'Gönderilen konular ilgimi çekmiyor.',
        SMS: 'Gönderilen konular ilgimi çekmiyor.',
        PHONE: 'Arama yapılan konular ilgimi çekmiyor',
      },
    },
    placeholders: {
      otherInput: 'Lütfen sebep giriniz...',
    },
    actions: {
      close: 'VAZGEÇ',
      approve: 'TERCİHİMİ DEĞİŞTİR',
    },
  },
  shouldUpdatePhoneTooltip: 'Mail güncellemek için telefon numaranızı güncellemeniz gerekmektedir.',
  changeEmailModal: {
    labels: {
      currentEmail: 'MEVCUT E-POSTA ADRESİ',
      newEmail: 'YENİ E-POSTA ADRESİ',
      emailConfirmation: 'YENİ E-POSTA ADRESİ',
    },
    placeholder: {
      currentEmail: 'Mevcut E-Posta Adresi',
      newEmail: 'Yeni E-Posta Adresi',
      emailConfirmation: 'Yeni E-Posta Adresi',
    },
    changeEmail: 'E-Posta Adresi Güncelle',
    changeEmailButton: 'E-POSTA ADRESİMİ GÜNCELLE VE DOĞRULA',
  },
  applyConfirmation: 'ONAYLIYORUM',
  close: 'KAPAT',
  update: 'GÜNCELLE',
  updateIbanDisabledTooltipText: 'Ödeme planlarının hazırlanmasından dolayı çarşamba ve perşembe günleri güncelleme yapılamamaktadır.',
  distrainedInfoText: 'Mağazanızın hacizli olması sebebiyle IBAN güncelleme işlemi yapılamamaktadır.',
};
